<template>
    <v-card
        class="py-4"
        color="white"
        rounded="lg"
        variant="flat"
    >
    <div class="kiwi-card-container auth-card-container py-3 px-3 px-md-6 px-lg-8">
        <div class="card-header">
            <div class="text-center mt-4">
                <h1 class="kiwi-fs-28 font-weight-semi-bold">Welcome to <router-link class="home-link" to="/">{{ institute.name }}</router-link></h1>
                <p class="kiwi-fs-14 mt-1 kiwi-text-light-black-2">Enter your credentials to access your account</p>
            </div>
        </div>
        <div class="card-body mt-4">
                <div class="kiwi-form-msg text-center">
                    <span class="kiwi-text-error" v-if="errorMessage.storemsg && errorMessage.storemsg.error">{{ errorMessage.storemsg.error }}</span>
                </div>
            <v-form :class="errorMessage.storemsg && errorMessage.storemsg.error ? 'mt-2' : ''">
                <div class="kiwi-form-group form-group" :class="(errorMessage.email || (errorMessage.storemsg && errorMessage.storemsg.email)) ? 'kiwi-form-error' : formData.email !== null ? 'kiwi-form-success' : ''">
                    <label for="" class="kiwi-form-label">Email Address</label>
                    <v-text-field 
                        type="email"
                        variant="outlined"
                        v-model="formData.email"
                        class="kiwi-form-input rounded-lg"
                        placeholder="abc@gmail.com"
                        ref="emailInput"
                        @input="inputUpdate"
                        @keydown.enter.prevent="keyPressEnter"
                        :rules="[handleErrors.rules.email]"
                    ></v-text-field>
                    <!-- <span class="form-msg d-block mt-2" v-if="(errorMessage.email || (errorMessage.storemsg && errorMessage.storemsg.email))">
                        <span class="kiwi-text-error d-block" v-if="errorMessage.email">{{ errorMessage.email }}</span>
                        <span class="kiwi-text-error d-block" v-if="errorMessage.storemsg && errorMessage.storemsg.email">{{ errorMessage.storemsg.email[0] }}</span>
                    </span> -->
                </div>
                <div class="kiwi-form-group form-group mt-2" :class="(errorMessage.password || (errorMessage.storemsg  && errorMessage.storemsg.password)) ? 'kiwi-form-error' : formData.password !== null ? 'kiwi-form-success' : ''">
                    <label for="" class="kiwi-form-label">Password</label>
                    <v-text-field
                        :type="toggleEye ? 'password' : 'text'"
                        v-model="formData.password"
                        :append-inner-icon="toggleEye ? 'mdi-eye' : 'mdi-eye-off'"
                        variant="outlined"
                        class="kiwi-form-input  kiwi-radius-4 kiwi-position-relative z-1 w-100"
                        placeholder="Enter your password"
                        @input="inputPassword"
                        @click:append-inner="togglePassword"
                        @keypress.enter="login "
                        :rules="[handleErrors.rules.password]"
                    />
                    <!-- <span class="form-msg d-block mt-2" v-if="(errorMessage.password || (errorMessage.storemsg && errorMessage.storemsg.password))">
                        <span class="kiwi-text-error">{{ (errorMessage.password === '' && !errorMessage.storemsg ? `` : errorMessage.password) || (errorMessage.storemsg && errorMessage.storemsg.password[0] ? errorMessage.storemsg.password[0] : '')}}</span>
                    </span> -->
                </div>
                <div class="kiwi-form-note kiwi-text-light-grey mt-4" v-if="$route.path !== '/login'">
                    By clicking sign up you agree  with our <router-link to="/terms-condition" target="_balnk" class="kiwi-text-black">Terms and Conditions</router-link> and <router-link to="/privacy" target="_blank" class="kiwi-text-black">Privacy Policy</router-link>.
                </div>
                <v-row v-else class="mt-4 mb-2">
                    <v-col cols="6" class="py-2">
                        <!-- <v-checkbox class="kiwi-checkbox" v-model="isRemember" label="Remember me" hide-details></v-checkbox> -->
                    </v-col>
                    <v-col cols="6" class="text-right py-2">
                        <router-link to="/forgot-password" @click.prevent="forgotPasswordLinkClicked" class="kiwi-text-primary">Forgot password?</router-link>
                    </v-col>
                </v-row>
                <div class="kiwi-form-btnwrap mt-4">
                    <v-btn
                        class="text-none text-uppercase mb-4 text-body-1 kiwi-bg-primary kiwi-text-white"
                        size="x-large"
                        variant="flat"
                        block
                        height="56"
                        :disabled="isSigninDisable"
                        :class="{'kiwi-button-disable kiwi-bg-disabled' : isSigninDisable}"
                        @click.prevent="login"
                    >
                        {{ !isSubmitting ? `Sign In` : `Signing in...`}}
                    </v-btn>
                </div>
                <template v-if="institute.$hasFeature('google-signup') || institute.$hasFeature('facebook-signup')">
                <v-row class="kiwi-or-divider align-center">
                    <v-col cols><v-divider class="kiwi-border-lightes-grey kiwi-no-opacity" /></v-col>
                    <v-col cols="3" md="2"><div class="kiwi-fs-14 text-center text-uppercase font-weight-semi-bold kiwi-text-light-grey">OR</div></v-col>
                    <v-col cols><v-divider class="kiwi-border-lightes-grey kiwi-no-opacity" /></v-col>
                </v-row>
                <v-row class="kiwi-form-social-btn-wrap">
                    <v-col cols="12" :md="institute.$hasFeature('google-signup') && institute.$hasFeature('facebook-signup') ? 6 : 12" v-if="institute.$hasFeature('google-signup')">
                        <div>
                            <v-btn
                                class="text-none mb-4 text-body-1 social-btn border kiwi-border-light-grey-1"
                                color="default"
                                size="large"
                                variant="flat"
                                block
                                v-if="!isGoogleUser"
                                @click.prevent="fetchGoogle"
                                :disabled="isProcessing"
                            >
                                <img src="@/assets/icon_google.png" class="mr-2 size-18" alt="Facebook Icon" />
                                Continue with Google
                            </v-btn>
                            <v-btn v-else
                                class="text-none mb-4 text-body-1 social-btn overflow-hidden border kiwi-border-light-grey-1"
                                color="default"
                                size="large"
                                variant="flat"
                                block
                                @click.prevent="fetchGoogle"
                                :disabled="isProcessing"
                            >
                                <div class="d-flex kiwi-minus-mx-15">
                                    <div class="d-flex mr-2 align-center">
                                        <div class="circle mr-1" style="width:18px; height:18px" v-if="isGoogleUser && isGoogleUser.photoURL">
                                            <img :src="isGoogleUser.photoURL" alt="Google User Icon" class="size-18" />
                                        </div>
                                        <div class="font-weight-semi-bold">
                                            Continue as <span class="text-capitalize">{{isGoogleUser ? `${isGoogleUser.displayName}` : ''}}</span> <br />
                                            <span class="font-weight-regular">{{ isGoogleUser ? isGoogleUser.email : '' }}</span>
                                        </div>
                                    </div>
                                    <img src="@/assets/icon_google.png" alt="Google Icon" class="size-18" />

                                </div>
                            </v-btn>
                        </div>
                    </v-col>
                    <v-col cols="12" :md="institute.$hasFeature('google-signup') && institute.$hasFeature('facebook-signup') ? 6 : 12" v-if="institute.$hasFeature('facebook-signup')">
                        <v-btn
                            class="text-none mb-4 text-body-1 social-btn border kiwi-border-light-grey-1"
                            color="default"
                            size="large"
                            variant="flat"
                            block
                            v-if="!isFacebookUser"
                            @click.prevent="fetchfacebook"
                            :disabled="isProcessing"
                        >
                            <img src="@/assets/icon_facebook.png" class="mr-2 size-18" alt="Facebook Icon" />
                            Continue with Facebook 
                        </v-btn>
                        <v-btn
                            class="text-none mb-4 text-body-1 social-btn overflow-hidden border kiwi-border-light-grey-1"
                            color="default"
                            size="large"
                            variant="flat"
                            block
                            v-else
                            @click.prevent="fetchfacebook"
                            :disabled="isProcessing"
                        >
                            <div class="d-flex kiwi-minus-mx-15">
                                <div class="d-flex mr-2 align-center">
                                    <div class="circle mr-1" style="width:18px; height:18px" v-if="isFacebookUser && isFacebookUser.photoURL">
                                        <img :src="isFacebookUser.photoURL" class="size-18" alt="Google Icon" />
                                    </div>
                                    <div class="font-weight-semi-bold"> 
                                        Continue as <span class="text-capitalize">{{isFacebookUser ? `${isFacebookUser.displayName}` : ''}}</span>
                                    </div>
                                </div>
                                <img src="@/assets/icon_facebook.png" alt="Facebook Icon" class="size-18" />

                            </div>
                        </v-btn>
                    </v-col>
                </v-row>
                </template>
                <div class="kiwi-form-footer-wrap mt-4 text-center" v-if="institute.$hasFeature('email-signup')">
                    <router-link :to="'/register'" @click.prevent="routerLinkCliecked" class="font-weight-medium text-none text-decoration-none kiwi-text-light-black-2">{{`Don't have an Account?`}} <span class="font-weight-semi-bold kiwi-text-primary">{{'Sign Up'}}</span></router-link>
                </div>
            </v-form>
        </div>
    </div>
    
      <SnackBar />
    </v-card>
</template>

<script setup>
import {api, apiWithoutAuth} from '@/plugins/axios';
import SnackBar from '@/components/SnackBar.vue'
import {useSocialLogin, isGoogleUser, isFacebookUser, isProcessing} from '@/composables/useSocialLogin'
import {submittingProcess, resetSubmitFrom, isSubmitting} from '@/handler/multipleFormSubmitPreventer';
import {useKiwiFormValidationCheck} from '@/stores/kiwiFormValidation';
import { storeToRefs } from 'pinia';
import {nextTick, onMounted, onUpdated, ref, computed} from 'vue';
import { AuthTokenService } from '@/handler/authService';
import { useRouter } from 'vue-router';
import {useConfirmer} from '@/stores/confirmer'
import { useValidation } from "@/composables/useValidation";
import { useInstituteStore } from '@/stores/institute/institute-store';
import { useAuthStore } from '@/stores/auth/authStore';
import { useRegisterStore } from '@/stores/registrationStore';
const authStore = useAuthStore();
const institute = useInstituteStore()
const router = useRouter();
const confirmer = useConfirmer()
const validation =  useKiwiFormValidationCheck();
const isRemember = ref(true);
const {openSnackbar, displayMsg } = storeToRefs(confirmer);
const {isValid, errorMessage } = storeToRefs(validation);
const isAuthenticated = ref(false);
validation.clearApiValidation();
const handleErrors = useValidation();
const bodyClick = ref(false)
const store = useRegisterStore()
const { formData } = storeToRefs(store)

JSON.parse(localStorage.getItem('token')) ? isAuthenticated.value = true : isAuthenticated.value = false
// const loginFormData = ref({
//     email: null,
//     password: null
// })
const emailInput = ref(null)
const isSigninDisable = computed(() => {
    return (bodyClick.value && !handleErrors.isValid.value) || isSubmitting.value
})
const routerLinkCliecked = () => {
    validation.clearApiValidation();
    if(isAuthenticated.value === true) {
        isAuthenticated.value = false
    }
}
const forgotPasswordLinkClicked = () => {
    router.push('/forgot-password')
}

const inputUpdate = () => {
    validation.clearApiValidation();
    validation.validEmail(formData.value.email)
}


const inputPassword = () => {
    validation.clearApiValidation();
    validation.validPassword(formData.value.password);
}

const toggleEye = ref(true)
const togglePassword = ()=> {
    toggleEye.value = !toggleEye.value
}

// if(localStorage.getItem('rememberMe')) {

//     if(router.currentRoute._value.path === '/login') {
//         try {
//             const response = api.get('user/checkauth/')
//             response.then(res => {
//                 if(res.message === 'Successful') {
//                     AuthTokenService.redirectToDashboardIfLoggedIn()
//                 }
//             }).catch(err => {
//                 // console.log(err.response.data.data.messages[0])
//                 confirmer.openSnackBar({type: 'error', msg: err.response.data.data.messages[0].message})
//                 if(!localStorage.getItem('is_refreshed'))  {
//                     try {
//                         const response = apiWithoutAuth.post('user/token/refresh/', {
//                             refresh: AuthTokenService.getRefreshToken()
//                         })
//                         localStorage.setItem('is_refreshed', true)
//                         confirmer.openSnackbar('success', response.message)
//                         AuthTokenService.setTokens(response.data.access, response.data.refresh, isRemember.value);
//                         AuthTokenService.redirectToDashboardIfLoggedIn()
//                     } catch(error) {
//                         AuthTokenService.clearTokens()
//                         validation.storeApiValidation(error.response.data)
//                         confirmer.openSnackbar('error', error.response.data.message)
//                     }
//                 }
//             }) 
//         } catch(error) {
//             // console.log('Error Remember me', error)
//             AuthTokenService.clearTokens()
//         }
        

//     }
    
// }

const login = async() => {
    if(isValid && formData.value.email && formData.value.password) {
        try {
            submittingProcess();
            const response = await apiWithoutAuth.post('/user/login/', {...formData.value})
            // localStorage.setItem('KiwiAuth', JSON.stringify(response.data))
            // localStorage.setItem('token', JSON.stringify(response.data.access_token))
            confirmer.openSnackBar({type: 'success', msg: response.data.message})
            isAuthenticated.value = true;
            // if(isRemember.value === true) {
            //     localStorage.setItem('rememberMe', isRemember.value)
            // }
            const { access_token, refresh_token, user_type } = response.data
            // Store tokens
            AuthTokenService.setTokens(access_token, refresh_token, isRemember.value);
            authStore.setUserType(user_type)
            resetSubmitFrom()
            if(user_type === 'institute') {
                router.push({name: 'ins_student'});
            }else if(user_type === 'agent') {
                router.push({name: 'agent_voucher'});
            }
            else {
                router.push('/dashboard')
            }
        } catch(error) {
            resetSubmitFrom()
            if(error.response && error.response.data.data.message) {
                validation.storeApiValidation(error.response.data)
                confirmer.openSnackBar({type: 'error', msg: error.response.data.data.message})
            }
            if(error.response && error.response.data.data.error) {
                validation.storeApiValidation(error.response.data)
                confirmer.openSnackBar({type: 'error', msg: error.response.data.data.error})
            }
            if(error.response.data.data.is_email_verified === false){
                AuthTokenService.setEmailCookie(formData.value.email)
                AuthTokenService.setVerifyToken(error.response.data.data.registration_token)
                router.push({name: 'sendVerificationOTP'})
            }
        }
    }
}

const keyPressEnter = (event) => {
    event.preventDefault();
}

const socialAuth = useSocialLogin(validation, confirmer);
const fetchGoogle = () => {
    socialAuth.signInWithGoogleMethod();
}
const fetchfacebook = () => {
    socialAuth.signInWithFacebookMethod();
}
function handleBodyClick(e) {
    if (!bodyClick.value) {
        bodyClick.value = true;
    }
    document.body.removeEventListener('click', handleBodyClick);
}
onMounted(() => {   
    formData.value = {
      email: null,
      password: null
    }
    authStore.cleanUserData()
    document.body.addEventListener('click', handleBodyClick);
})
</script>
